module.exports = __webpack_public_path__ + "static/bellclick2.23f0bf74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellclick2.jpg
// module id = 1256
// module chunks = 35783957827783